import * as React from "react";
const SvgSuitcase = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 20"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M2 20V19C1.45 19 0.979167 18.8042 0.5875 18.4125C0.195833 18.0208 0 17.55 0 17V6C0 5.45 0.195833 4.97917 0.5875 4.5875C0.979167 4.19583 1.45 4 2 4H4V1C4 0.716667 4.09583 0.479167 4.2875 0.2875C4.47917 0.0958333 4.71667 0 5 0H9C9.28333 0 9.52083 0.0958333 9.7125 0.2875C9.90417 0.479167 10 0.716667 10 1V4H12C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6V17C14 17.55 13.8042 18.0208 13.4125 18.4125C13.0208 18.8042 12.55 19 12 19V20H10V19H4V20H2ZM6 4H8V2H6V4ZM9.5875 9.6625C10.4292 9.4375 11.2333 9.1 12 8.65V6H2V8.65C2.76667 9.1 3.57083 9.4375 4.4125 9.6625C5.25417 9.8875 6.11667 10 7 10C7.88333 10 8.74583 9.8875 9.5875 9.6625ZM6 13V11.95C5.3 11.8667 4.61667 11.7417 3.95 11.575C3.28333 11.4083 2.63333 11.1833 2 10.9V17H12V10.9C11.3667 11.1833 10.7167 11.4083 10.05 11.575C9.38333 11.7417 8.7 11.8667 8 11.95V13H6Z"
    />
  </svg>
);
export default SvgSuitcase;
